import { render, staticRenderFns } from "./ShowTaskDetail.vue?vue&type=template&id=ba93ea5c&"
import script from "./ShowTaskDetail.vue?vue&type=script&lang=js&"
export * from "./ShowTaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports